import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Renderer2,
} from '@angular/core';
import {
  IonContent,
  IonicSlides,
  Platform,
  ToastController,
} from '@ionic/angular';
import { GetDataService } from 'src/providers/get-data.service';
import { PostDataService } from 'src/providers/post-data.service';
import { Router } from '@angular/router';
import { IonLoaderService } from 'src/providers/ion-loader.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { SeoService } from 'src/providers/seo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @ViewChild('content', { read: IonContent }) content!: IonContent;
  dataLoaded: boolean = false;
  imageUrl = environment.image_Url;
  languageId: any;
  footerEmail: any = '';
  footerPhone: any = '';
  copyrightText: any = '';

  constructor(
    private platform: Platform,
    private getData: GetDataService,
    private postData: PostDataService,
    private renderer: Renderer2,
    private el: ElementRef,
    private router: Router,
    private loader: IonLoaderService,
    public sanitizer: DomSanitizer,
    private cookieService: CookieService,
    private SEO_services: SeoService,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    // await this.loader.simpleLoader();
    this.languageId = localStorage.getItem('LanguageID');
    await this.getSiteSetting();
  }

  getSiteSetting() {
    this.getData.getHeader(this.languageId).then(async (res: any) => {
      if (res) {
        this.footerEmail = res?.data[0]?.email;
        this.footerPhone = res?.data[0]?.phone;
        this.copyrightText = res?.data[0]?.copyrightText;

        //  await this.loader.dismissLoader();
      } else {
        this.dataLoaded = true;
        //  await this.loader.dismissLoader();
      }
    });
  }
}
